<!-- <ion-app> -->
  <!-- Logout Loader Overlay - shown at app level so it persists when layout is hidden -->
  @if (isLoggingOut) {
    <div class="logout-loader-overlay">
      <div class="logout-loader-content">
        <div class="logout-spinner"></div>
        <p class="logout-message">Logging out...</p>
      </div>
    </div>
  }

  <!-- Show quick-activate component for QuickActivated users (without side menu) -->
  @if (isLoggedIn && isQuickActivated) {
    <router-outlet></router-outlet>
  }

  <!-- Show sidemenu layout (with header inside) only when user is logged in and on appropriate routes and not QuickActivated -->
  @if (showLayout && !isQuickActivated) {
    <app-header></app-header>
    <app-sidemenu>
      <router-outlet></router-outlet>
    </app-sidemenu>
    <!-- PE-0000 — assistant only on signed-in layout, and only in local/dev -->
    @if (showPatientChat) {
      <app-patient-chat></app-patient-chat>
    }
  }

  <!-- Show only router outlet when user is not logged in or on no-layout routes -->
  @if (!showLayout && !isQuickActivated) {
    <router-outlet></router-outlet>
  }
<!-- </ion-app> -->